/* Trust Badge Strip — GSAP infinite ticker */
(function () {
  'use strict';

  function initStrip(section) {
    const track = section.querySelector('.trust-badge-strip__track');
    if (!track) return;

    const speed       = parseFloat(section.dataset.scrollSpeed) || 30;
    const pauseOnHover = section.dataset.pauseOnHover !== 'false';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion) return;

    if (typeof gsap === 'undefined') {
      console.warn('[trust-badge-strip] GSAP not found.');
      return;
    }

    /* Clone badge list once for a seamless loop */
    const original = Array.from(track.children);
    const clone = document.createElement('div');
    clone.setAttribute('aria-hidden', 'true');
    clone.style.display = 'contents';
    original.forEach(function (badge) {
      clone.appendChild(badge.cloneNode(true));
    });
    track.appendChild(clone);

    /* Measure the width of one set (original badges + gap) */
    function getLoopWidth() {
      /* Sum of first N children (the originals) including their gap offset */
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      return original.reduce(function (acc, el) {
        return acc + el.getBoundingClientRect().width + gap;
      }, 0);
    }

    let tween;

    function buildTween() {
      if (tween) tween.kill();
      const loopWidth = getLoopWidth();
      tween = gsap.to(track, {
        x: -loopWidth,
        duration: speed,
        ease: 'none',
        repeat: -1,
        modifiers: {
          x: function (x) {
            /* Keep x in the range [-loopWidth, 0) */
            return (parseFloat(x) % loopWidth) + 'px';
          }
        }
      });
    }

    buildTween();

    /* Pause / resume on hover */
    if (pauseOnHover) {
      section.addEventListener('mouseenter', function () { tween && tween.pause(); });
      section.addEventListener('mouseleave', function () { tween && tween.resume(); });
      section.addEventListener('focusin',    function () { tween && tween.pause(); });
      section.addEventListener('focusout',   function () { tween && tween.resume(); });
    }

    /* Rebuild on resize to recalculate loop width */
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(buildTween, 250);
    });
  }

  function init() {
    document.querySelectorAll('[data-trust-strip]').forEach(initStrip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify theme editor — re-init when section is selected/reloaded */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-trust-strip]');
    if (section) initStrip(section);
  });
})();
